import api from './api';

export const refreshMonitoring = (start, end, detail = false) => {
  return api.post('/monitor/refresh', null, {
    params: { start, end, detail }
  }).then(r => r.data);
};

export const getMassSendMembers = (taskId) => {
  return api.get(`/monitor/tasks/mass-send/${taskId}/members`).then(r => r.data);
};

export const getMessageDetails = (msgid) => {
  return api.get(`/monitor/messages/${encodeURIComponent(msgid)}/details`).then(r => r.data);
};

export const getMomentDetails = (momentId) => {
  return api.get(`/monitor/moments/${encodeURIComponent(momentId)}/details`).then(r => r.data);
};

export const getMemberCoverage = ({ corpId, channel, start, end, byMember = false }) => {
  const params = { channel, start, end, byMember };
  if (corpId) params.corpId = corpId; // 可选
  return api.get('/monitor/coverage/members', { params }).then(r => r.data);
};

export const getFailureTop = ({ corpId, channel, start, end, limit = 10 }) => {
  const params = { channel, start, end, limit };
  if (corpId) params.corpId = corpId;
  return api.get('/monitor/failures/top', { params }).then(r => r.data);
};

export const getMonitoringContext = () => {
  return api.get('/monitor/context').then(r => r.data);
};

export const getRecentEvents = ({ category, page = 0, size = 20, start, end }) => {
  const params = { category, page, size };
  if (start) params.start = start;
  if (end) params.end = end;
  return api.get('/monitor/events/recent', { params }).then(r => r.data);
};

// 成员完成率（合并三渠道），支持按rate排序
export const getCompletionByMember = ({ corpId, start, end, order = 'acs', page = 0, size = 10, keyword, onlyPending = false }) => {
  const params = { start, end, order, page, size, onlyPending };
  if (keyword) params.keyword = keyword;
  if (corpId) params.corpId = corpId;
  return api.get('/monitor/completion/members', { params }).then(r => r.data);
};
